import jsonColorData from 'src/configs/styles/management/colors.json'
import jsonLightBaseData from 'src/configs/styles/management/light/base.json'
import jsonLightComponentsData from 'src/configs/styles/management/light/components.json'
import { EntriesObject, EntriesDiffObject } from 'src/types/common'
import ConfigProcessor from '../core/ConfigProcessor'
import { mergeDeepObjects } from 'src/configs/styles/core'

type JsonColor = typeof jsonColorData
type ColorName = keyof JsonColor
type ShadeName =
  | '50'
  | '100'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '700'
  | '800'
  | '900'
  | 'A100'
  | 'A200'
  | 'A400'
  | 'A700'
type Shades = {
  [k in ShadeName]?: string
}
type CustomColor = {
  [k in ColorName]?: Shades
}

const transformColors = () => {
  const transformedObj: CustomColor = {}

  ;(<EntriesObject>Object).entries(jsonColorData).forEach(([colorName, colorShades]) => {
    transformedObj[colorName] = {} as Shades
    ;(<EntriesDiffObject>Object).entries(colorShades).forEach(([shadeName, shadeConfig]) => {
      ;(transformedObj[colorName] as Shades)[shadeName] = shadeConfig.value
    })
  })

  return transformedObj
}

export const color = transformColors()

const initialConfig: any = {
  ...color
}

const totalJson = mergeDeepObjects({}, jsonLightBaseData, jsonLightComponentsData)
const processor = new ConfigProcessor()
export const finalConfig = processor.traverseAll(totalJson, initialConfig)
